import Request from './request'

const Device_Statistic = {
  getDeviceStatus (id, callback) {
    Request.get('device-statistic/status/' + id).then(callback).catch(this.bad_answer)
  },
  getDeviceSpeed (id, params, callback) {
    Request.post('device-statistic/speed/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceTimeline (id, params, callback) {
    Request.post('device-statistic/timeline/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceTemper (id, params, callback) {
    Request.post('device-statistic/temperature/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceCPU (id, params, callback) {
    Request.post('device-statistic/cpu-load/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceTraffic (params, callback) {
    Request.get('device-statistic/traffic/' + params.dev_id + '?start='+ params.date_start +'&end='+ params.date_end +'&use_utc='+ params.utc +'&csv='+ params.csv + '&all_ifaces=' + params.all_ifaces ).then(callback).catch(this.bad_answer)
  },
  getDeviceTrafficcsv (params, callback) {
    Request.get('device-statistic/traffic/' + params.dev_id + '?start='+ params.date_start +'&end='+ params.date_end +'&use_utc='+ params.utc +'&csv='+ params.csv + '&all_ifaces=' + params.all_ifaces ).then(callback).catch(this.bad_answer)
  },
}
export default Device_Statistic
